export default {
  "agentDetails.title": "提现审批",
  "agentDetails.thead.index": "#序号",
  "agentDetails.thead.applyId": "申请ID",
  "agentDetails.thead.userno": "用户编号",
  "agentDetails.thead.email": "邮箱",
  "agentDetails.thead.directInviteUserNum": "直接邀请人数",
  "agentDetails.thead.indirectInviteUserNum": "间接邀请人数",
  "agentDetails.thead.directInviteUserBet": "直接投注额",
  "agentDetails.thead.indirectInviteUserBet": "间接投注额",
  "agentDetails.thead.directInviteBonus": "直接佣金",
  "agentDetails.thead.indirectInviteBonus": "间接佣金",
};
